import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const FIT_SETTINGS_UPDATE_RESOURCE = "fit-settings" as const;
export const FIT_SETTINGS_UPDATE_API_PATH = `/v1/${FIT_SETTINGS_UPDATE_RESOURCE}` as const;

export type FitSettingsUpdateBody =
  paths[typeof FIT_SETTINGS_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type FitSettingsUpdateResponse =
  paths[typeof FIT_SETTINGS_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useFitSettingsUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<FitSettingsUpdateResponse, Error, FitSettingsUpdateBody>({
    mutationFn: async (fitSettings: FitSettingsUpdateBody) => {
      const response = await alphartisApiAxios.patch<FitSettingsUpdateResponse>(
        FIT_SETTINGS_UPDATE_API_PATH,
        fitSettings,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [FIT_SETTINGS_UPDATE_RESOURCE],
      });
    },
  });
};
